import { ApplicationConfig, DEFAULT_CURRENCY_CODE, importProvidersFrom, LOCALE_ID, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { AppPreset } from './app.presets';
import { environment } from '../environments/environment';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { ElasticSearchService } from '@common/api-server';
import { NgxPermissionsModule } from 'ngx-permissions';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiServerService } from '@common/api-server/api-server';
import { DateFnsConfigurationService } from 'ngx-date-fns';

import { registerLocaleData } from '@angular/common'; // <-- Importa esto
import localeEs from '@angular/common/locales/es';    // <-- Importa los datos de 'es'
registerLocaleData(localeEs, 'es');

const spanishConfig = new DateFnsConfigurationService();
const enGBConfig = new DateFnsConfigurationService();

export function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    { provide: 'FIREBASE_REGION', useValue: environment.firebaseConfig.region },
    provideFirebaseApp(() =>
      initializeApp(environment.firebaseConfig)
    ),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideFunctions(() => getFunctions(getApp(), environment.firebaseConfig.region)),
    importProvidersFrom([
      NgxPermissionsModule.forRoot()
    ]), 
    provideStorage(() => getStorage()),
    ElasticSearchService,          
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    { provide: LOCALE_ID, useValue: "es" },
    { provide: DateFnsConfigurationService, useValue: enGBConfig },
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
      defaultLanguage: 'es'
    }),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: AppPreset,
        options: {
          darkModeSelector: '._-app-dark',
          prefix: 'p',
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng, components, util'
          }
        }
      }
    }),
    DialogService,
    ConfirmationService,
    MessageService,
    ApiServerService
    
  ]
};
